const TABS = [
  { key: "estimate", label: "Estimate" },
  { key: "scope", label: "Scope" },
  { key: "time", label: "Time" },
  { key: "quote", label: "Quote" },
  { key: "overrides", label: "Adjust" },
  { key: "history", label: "History" },
];

export default function QuoteWorkspaceTabs({
  activeTab,
  onChange,
  quoteValidation,
}) {
  const hasIssues = quoteValidation?.isValid === false;

  return (
    <div className="border-b border-[#edebe9] bg-white px-4">
      <div className="flex h-10 items-center gap-1 overflow-x-auto">
        {TABS.map((tab) => {
          const isActive = activeTab === tab.key;
          const showWarning = tab.key === "quote" && hasIssues;

          return (
            <button
              key={tab.key}
              type="button"
              onClick={() => onChange(tab.key)}
              className={[
                "relative flex items-center gap-2 rounded-sm px-3 py-1.5 text-sm font-medium",
                isActive
                  ? "bg-[#f3f2f1] text-[#201f1e]"
                  : "text-[#605e5c] hover:bg-[#faf9f8] hover:text-[#201f1e]",
              ].join(" ")}
            >
              <span>{tab.label}</span>

              {showWarning && (
                <span
                  className="h-2 w-2 rounded-full bg-[#d13438]"
                  title="Needs review"
                />
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}